import React from 'react'

const Layout = ({ buttonList, activeKey, setActiveKey, miscellaneousSidebar }) => {
  return (
    <div className='misc-layout'>
      <div className='misc-sidebar'>
        {buttonList.map(({ key, label }) => (
          <div
            key={key}
            className={`misc-tab-button ${activeKey === key ? 'active' : ''}`}
            onClick={() => setActiveKey(key)}
          >
            {label}
          </div>
        ))}
      </div>
      <div className='misc-content'>
        {miscellaneousSidebar(activeKey)}
      </div>
    </div>
  )
}

export default Layout
